import { Injectable } from '@angular/core';
import { Component, OnInit, Inject, ViewChild, ElementRef, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MessagerComponent } from '../messager/messager/messager.component';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MultiFamilyService } from './multifamily.service';
import { Questions, Templates } from './mfmodels';
import { Observable } from 'rxjs';
import { ReactiveFormsModule,FormsModule } from '@angular/forms';

@Component({
  selector: 'app-multifamily',
  templateUrl: './multifamily.component.html',
  styleUrls: ['./multifamily.component.css']
})
export class MultifamilyComponent implements OnInit {

  constructor(private mfService:MultiFamilyService, public dialog: MatDialog, public messager: MessagerComponent) { }

  templateStyle: number;
  showQuestions: boolean;
  templateName: string;
  numFields: number = 0;
  question$: Observable<Questions[]>;
  template$: Observable<Templates[]>;

  selectedQuestionList : any[] =[];
  //selectedQuestionList;
  templates;
  templateDesc: string = '';
  templateId;
  searchTerm;
  editMode: boolean = false;

  fullQuestionArray;

  ngOnInit(): void {

    this.mfService.fetchQuestions();
    this.mfService.fetchTemplates();

    //load questions & templates
    this.mfService.questions$.subscribe(res => this.fullQuestionArray = res);
    this.mfService.template$.subscribe(res => this.templates = res);
    this.showQuestions = false
    this.templateStyle = 2
    console.log(this.templates);

  }


  getHumanType(type){
    switch(type){
      case 1:
      return 'Input field';
      case 2:
      return 'Checkbox';
      case 3:
      return 'Number';
      case 4:
      return 'Dropdown';
      case 5:
      return 'Text Box'
      default:
      return 'N/A';

    }
  }


  clearTemplate(): void {
    this.selectedQuestionList.length = 0;
    this.templateDesc = '';
    this.templateName = '';
    this.numFields = 0;
  }

  backFunction():void{
    this.clearTemplate()
    this.showQuestions = false
    this.templateStyle = 2
  }

  saveTemplate(): void {

    console.log(JSON.stringify(this.selectedQuestionList));

    let newTemplate = {
      name : this.templateName,
      fields: (JSON.stringify(this.selectedQuestionList)),
      numfields : this.numFields,
      description: this.templateDesc
    }
    this.mfService.createTemplate(newTemplate);
    this.clearTemplate();
    this.backFunction();
  }

  setTemplateStyle(style): void {
    this.templateStyle = style;
    if(style == 1){
      this.showQuestions = true;
    } else if(style == 2) {
      this.showQuestions = false;
    } else if (style == 3) {
      this.showQuestions = true;
      this.editMode = true;
    }
  }

  addQuestionToTemplate(index): void {

    this.selectedQuestionList.push(this.fullQuestionArray[index]);
    this.numFields++;
    console.log(this.selectedQuestionList);

  }

  search(): void {
    if(this.searchTerm!== ""){
      let searchValue = this.searchTerm.toLocaleLowerCase();

          this.fullQuestionArray = this.fullQuestionArray.filter(question =>{
            return question.descr.toLocaleLowerCase().match(searchValue );
          });
        }else {
          this.mfService.fetchQuestions();
        }
  }



  removeQuestion(index): void {

    console.log(index);
    console.log(this.selectedQuestionList);
    let newData = this.selectedQuestionList.slice(0);
    newData.splice(index, 1);
    console.log(newData);
    this.selectedQuestionList = newData;
    this.numFields--;

  }

  copyDialog(obj): void {
    const dialogRef = this.dialog.open(CopyMultifamilyComponent, {
      width: '400px',
      height: '450px',
      data: {
        templateName : obj.name
      },
      panelClass: 'edit-dialog-container'
    }).afterClosed().subscribe(
      result => {
        this.mfService.copyTemplate(obj, result);
      }
    );
  }

  addDialog(): void {
    const dialogRef = this.dialog.open(NewQuestionComponent, {
      width: '700px',
      height: '650px',
      data: {
        mode: 1
      },
      panelClass: 'edit-dialog-container'
    }).afterClosed().subscribe(
      result => {
        console.log(result);
        result.inpt = parseInt(result.inpt);

        //if new questions automatically go to template

        //this.fullQuestionArray.push(result);
        this.mfService.createQuestion(result);

      }
    );
    // const dialogRef = this.dialog.open();
  }

  delete(question): void {
    this.mfService.deleteQuestion(question);
  }

  editDialog(question): void {

    console.log(question);

    const dialogRef = this.dialog.open(NewQuestionComponent, {
      width: '700px',
      height: '650px',
      data: {
        question: question,
        mode : 2
      },
      panelClass: 'edit-dialog-container'
    }).afterClosed().subscribe(
      result => {
        result.inpt = parseInt(result.inpt);
        result.id = parseInt(question.id);

        console.log(result);
        //if new questions automatically go to template

        //this.fullQuestionArray.push(result);
        this.mfService.updateQuestion(result);

      }
    );
    // const dialogRef = this.dialog.open();
  }


  editTemplate(obj): void {

    this.mfService.getSingleTemplate(obj.id).subscribe(
      res => {
        this.templateName = res.Response.name;
        this.numFields = res.Response.numFields;
        this.selectedQuestionList = res.Response.fields;
        this.templateDesc = res.Response.description;
        this.templateId = res.Response.id;
        this.setTemplateStyle(3);
      }, err => {
        this.messager.openSnackBar('Error editing ' + obj.name, '', 'errorAlert');
      }
    )
  }

  updateTemplate(): void {
    let template = {
      id : this.templateId,
      name : this.templateName,
      fields: (JSON.stringify(this.selectedQuestionList)),
      numfields : this.selectedQuestionList.length,
      description: this.templateDesc
    }

    this.mfService.updateTemplate(template);
    this.clearTemplate();
    this.backFunction();
  }

}

@Component({
  selector: 'app-newquestion',
  templateUrl: './newquestion.component.html'
})

export class NewQuestionComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<NewQuestionComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public fb: FormBuilder, public cdr: ChangeDetectorRef ){

  }

  @ViewChild('optionValue', {read: false, static: false}) // reference the plan name field
  optionValueInputRef: ElementRef;

  questionForm = new FormGroup({
    descr: new FormControl(''),
    inpt: new FormControl('')
  });

  choices: string[] = [];

  ngOnInit(): void {

    console.log(this.data);
    if(this.data.mode == 2)
    {
      this.questionForm.get('descr').setValue(this.data.question.descr);
      this.questionForm.get('inpt').setValue(this.data.question.inpt);
      //push all objects in this.data.question.choices to this.choices
      this.data.question.choices?.forEach(element => {
        this.choices.push(element)
      });
    }

    this.cdr.detectChanges();
    console.log(this.choices.length)

  }

  addOption(option: string){

    this.choices.push(option);
    this.optionValueInputRef.nativeElement.value = '';

  }

  removeOption(index){
    this.choices.splice(index,1)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveClick(): void {


    this.dialogRef.close({
      descr : this.questionForm.get('descr').value,
      inpt: this.questionForm.get('inpt').value,
      choices: this.choices
    });


  }

}


@Component({
  selector: 'app-copy-component',
  templateUrl: './copymultifamily.component.html',
})
export class CopyMultifamilyComponent {


  copyForm = new FormGroup({
    newName: new FormControl(''),
    newDesc: new FormControl('')
  });

  templateName;

  constructor(public dref: MatDialogRef<CopyMultifamilyComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

    this.templateName = data.templateName;

  }

}



